<script setup lang="ts">
import { useStore } from "vuex";
import RotateClockwise from "@/components/icons/RotateClockwise.vue";
import RotateCounterClockwise from "@/components/icons/RotateCounterClockwise.vue";
import ZoomIn from "@/components/icons/ZoomIn.vue";
import ZoomOut from "@/components/icons/ZoomOut.vue";
import { computed } from "vue";

const store = useStore();
const i18n = window.measurementSelectorVariables.i18n;

const rotation = computed(() => store.getters.rotation);
const zoom = computed(() => store.getters.zoom);
const updateZoom = (data: number) => store.commit('updateZoom', data);
const updateRotation = (data: number) => store.commit('updateRotation', data);
</script>

<template>
	<div class="preview-buttongroup">
		<button
			@click="updateRotation( rotation - 90 )"
			type="button"
			class="preview-buttongroup__button"
			:aria-label="i18n.previewControls.rotateCounterClockwise"
		>
			<RotateCounterClockwise aria-hidden="true" />
		</button>
		<button
			@click="updateRotation( rotation + 90 )"
			type="button"
			class="preview-buttongroup__button"
			:aria-label="i18n.previewControls.rotateClockwise"
		>
			<RotateClockwise aria-hidden="true" />
		</button>
		<button
			@click="updateZoom( Math.max( 1, zoom - 1 ) )"
			type="button"
			class="preview-buttongroup__button"
			:aria-label="i18n.previewControls.zoomOut"
		>
			<ZoomOut aria-hidden="true" />
		</button>
		<button
			@click="updateZoom( zoom + 1 )"
			type="button"
			class="preview-buttongroup__button"
			:aria-label="i18n.previewControls.zoomIn"
		>
			<ZoomIn aria-hidden="true" />
		</button>
	</div>
</template>

<style scoped lang="scss">
	.preview-buttongroup {
		display: none;
		.kps-gallery.is-open & { // only show when slider is full-screen
			display: flex;
			justify-content: space-between;
			width: 150px;
			float: right;
		}
	}

	.preview-buttongroup__button {
		background: $white;
		width: 30px;
		height: 30px;
		border-radius: 100%;
		padding: 2px 0 0 1px;
		line-height: 0;
	}
</style>
